import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import Account from 'modules/Account';
export const useCountrySettings = ()=>{
    const countrySettings = useSelector(Account.selectors.countrySettings);
    const fetchCountrySettings = useAction(Account.actions.fetchCountrySettings);
    useEffect(()=>{
        fetchCountrySettings();
    }, []);
    return countrySettings;
};
